import * as React from 'react';
import toast from 'cogo-toast';
import { Redirect } from 'react-router-dom';
import { Page, Grid, Form, Button, Alert } from 'tabler-react';

import Request from '../../shared/request';
import PageComponent from '../PageComponent';
import store from '../../shared/store';

const NO_CAPTCHA = { captcha: '', captchaValue: '', captchaToken: '', captchaError: '' };

class EmailConfirm extends PageComponent {
  state = {
    isProcessing: false,
    isProcessingResend: false,
    passcode: null,
    resendTimeout: 0,
    captcha: '',
    captchaValue: '',
    captchaToken: '',
    captchaError: '',
  };

  componentDidMount() {
    if (store.user.status === 'UNCONFIRM') {
      const search = new URLSearchParams(window.location.search);
      if (search.get('token')) {
        this.actionConfirmCode({ confirmToken: search.get('token') });
      } else {
        this.actionResendCode();
      }
    }
  }

  handleSubmit = event => {
    event.preventDefault();
    this.actionConfirmCode({ passcode: this.state.passcode });
  };

  handleResendCode = event => {
    event.preventDefault();
    this.actionResendCode();
  };

  async actionConfirmCode(data) {
    this.setState({ isProcessing: true });
    const res = await Request.call('confirmUserEmail', data);
    if (res) {
      toast.success('确认成功');
      store.updateUser();
    }
    this.setState({ isProcessing: false });
  }

  async actionResendCode(captchaBody) {
    if (this.state.isProcessingResend) return;
    this.setState({ isProcessingResend: true });
    let res;
    try {
      res = await Request.call('sendPasscode', {
        type: 'email',
        from: 'CONFIRM_EMAIL',
        email: store.user.email,
        ...captchaBody,
      });
    } catch (err) {
      this.setState({ isProcessingResend: false });
      throw err;
    }
    if (res && res.code === 11138) {
      // 与新图同一次 setState 解除 disabled：输入框带 disabled 挂载时 autoFocus 会失效
      this.setState({
        isProcessingResend: false,
        captcha: res.data.captcha,
        captchaToken: res.data.captchaToken,
        captchaValue: '',
        captchaError: captchaBody ? res.message : '',
      });
      return;
    }
    // 其他失败 Request 已 toast，必须关弹层，否则 toast 被遮罩压住
    this.setState({ isProcessingResend: false, ...NO_CAPTCHA });
    if (res) {
      this.setResendTimer();
      toast.success('发送成功');
    }
  }

  resetCaptcha = () => this.setState(NO_CAPTCHA);

  closeCaptcha = () => {
    if (this.state.isProcessingResend) return;
    this.resetCaptcha();
  };

  refreshCaptcha = () => {
    this.actionResendCode();
  };

  submitCaptcha = event => {
    event.preventDefault();
    const captchaValue = this.state.captchaValue.trim();
    if (!captchaValue) {
      toast.warn('请输入安全码');
      return;
    }
    this.actionResendCode({ captcha: captchaValue, captchaToken: this.state.captchaToken });
  };

  setResendTimer() {
    let { resendTimeout } = this.state;
    if (!resendTimeout) resendTimeout = 60;
    this.setState({ resendTimeout: resendTimeout - 1 });
    if (resendTimeout - 1 > 0) {
      setTimeout(this.setResendTimer.bind(this), 1000);
    }
  }

  render() {
    const {
      isProcessingResend,
      isProcessing,
      resendTimeout,
      captcha,
      captchaValue,
      captchaToken,
      captchaError,
    } = this.state;
    if (store.user.status === 'OK') return <Redirect to="/dashboard" />;

    return (
      <Grid.Row className="miao-setting">
        <Grid.Col xl={6} offsetXl={3} lg={6} offsetLg={3}>
          <Page.Card title="确认邮箱">
            <Alert type="success">
              确认邮箱即可获得VIP试用，请到邮箱查收验证码，如果没有请查看Spam/垃圾箱。
            </Alert>
            <Form onSubmit={this.handleSubmit}>
              <Form.InputGroup
                append={
                  <Button
                    RootComponent="button"
                    type="button"
                    disabled={isProcessingResend || resendTimeout}
                    onClick={this.handleResendCode}>
                    {resendTimeout ? `过${resendTimeout}秒重发` : '重发验证码'}
                  </Button>
                }>
                <Form.Input
                  onChange={e => this.setState({ passcode: e.target.value })}
                  placeholder="Enter confirm code"
                  autoComplete="off"
                />
              </Form.InputGroup>
              <Button
                className="miao-setting-btn"
                disabled={isProcessing}
                loading={isProcessing}
                type="submit"
                color="primary"
                value="Submit">
                确认
              </Button>
            </Form>
            {captcha ? (
              <div className="captcha">
                <div className="content">
                  <div className="header">
                    <div className="title">安全验证</div>
                    <i className="ri-close-circle-line" onClick={this.closeCaptcha} />
                  </div>
                  <form className="body" onSubmit={this.submitCaptcha}>
                    <img
                      src={`data:image/png;base64,${captcha}`}
                      onClick={this.refreshCaptcha}
                      title="看不清？点击图片刷新"
                      alt="code"
                    />
                    <Form.Input
                      key={captchaToken}
                      onChange={e => this.setState({ captchaValue: e.target.value })}
                      type="text"
                      autoComplete="off"
                      autoFocus
                      disabled={isProcessingResend}
                      value={captchaValue}
                      error={captchaError}
                      placeholder="请输入安全码"
                    />
                    <Button
                      className="miao-setting-btn"
                      type="submit"
                      color="primary"
                      loading={isProcessingResend}
                      disabled={isProcessingResend}>
                      完成验证
                    </Button>
                  </form>
                </div>
              </div>
            ) : null}
          </Page.Card>
        </Grid.Col>
      </Grid.Row>
    );
  }
}

export default EmailConfirm;
